import dayjs from "dayjs";
import { AxiosError } from "axios";

export const getDefaultExportDate = () => dayjs();

export const getExportDateParam = (date: dayjs.Dayjs) =>
  date.format("YYYY-MM-DD");

export const getFilenameFromContentDisposition = (header?: string) => {
  if (!header) return "";

  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1]);

  const filenameMatch = header.match(/filename="?([^"]+)"?/i);
  return filenameMatch?.[1] ?? "";
};

export const getGb1ExportFilename = (date: dayjs.Dayjs) =>
  `gb1_${date.format("YYYY-MM-DD")}.xlsx`;

export const downloadBlob = (filename: string, blob: Blob) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const getExportErrorMessage = async (error: unknown) => {
  const responseData = (error as AxiosError<Blob>).response?.data;
  if (!(responseData instanceof Blob)) return "";

  const text = await responseData.text();
  if (!text) return "";

  try {
    const data = JSON.parse(text) as {
      message?: string;
      error?: string;
      detail?: string;
    };

    return data.message || data.error || data.detail || "";
  } catch {
    return text;
  }
};
